// HU-42 (MG-ILE-61) · tarea 42-2. Administración › Comité de Farmacovigilancia.
//
// Contrato del AT S3 §2.2.6 y de `administracion/interfaces/http/esquemas.py` (42-1): `ComiteSalida`
// con la composición vigente en una fecha, el historial, los cargos del procedimiento, los cargos sin
// titular y las advertencias cruzadas con Usuarios y Destinatarios, todo con su texto armado por el
// servidor (`texto_de_la_vigencia`, `texto`). El Comité es corporativo (RN-40): no hay país.

import { pedir, segUuid } from './cliente';

export type MiembroDelComite = {
  miembro_id: string;
  cargo: string;
  nombre: string;
  correo: string | null;
  vigente_desde: string;
  vigente_hasta: string | null;
  /** «vigente desde 01/10/2026». */
  texto_de_la_vigencia: string;
  /** `reemplazar` y `retirar`, solo con la vigencia abierta. */
  acciones_permitidas: string[];
};

export type ComiteDeFarmacovigilancia = {
  dia: string;
  miembros: MiembroDelComite[];
  /** Todas las designaciones, de la más reciente a la más antigua (C2). */
  historial: { cargo: string; nombre: string; texto_de_la_vigencia: string }[];
  cargos_del_procedimiento: string[];
  /** C5: «El cargo Asesoría Técnica no tiene titular vigente». */
  cargos_del_procedimiento_sin_cubrir: { cargo: string; texto: string }[];
  /** C6: `sin_rol_comite` · `sin_aviso_caso_registrado`, con su texto. */
  advertencias: { tipo: string; texto: string }[];
  /** `designar`. */
  acciones_permitidas: string[];
};

const RUTA = '/administracion/comite';

/** Endpoint 52. Sin `dia`, la composición de hoy; el FAR-03 la pide con la fecha de la evaluación (C2). */
export function verComite(dia?: string) {
  return pedir<ComiteDeFarmacovigilancia>(dia ? `${RUTA}?dia=${encodeURIComponent(dia)}` : RUTA);
}

/** C1. `desde` vacío = hoy. */
export function designarMiembro(designacion: { cargo: string; nombre: string; correo: string | null; desde: string | null }) {
  return pedir<MiembroDelComite>(RUTA, { metodo: 'POST', cuerpo: designacion });
}

/** C2. Una sola operación: el Comité nunca queda vacío entre dos llamadas. */
export function reemplazarMiembro(reemplazo: { saliente_id: string; cargo: string; nombre: string; correo: string | null; dia: string | null }) {
  return pedir<MiembroDelComite[]>(`${RUTA}/reemplazos`, { metodo: 'POST', cuerpo: reemplazo });
}

/** C3. Si el Comité quedaría sin miembros vigentes, 422 y nada cambia. */
export function retirarMiembro(miembroId: string, dia: string | null) {
  return pedir<MiembroDelComite>(`${RUTA}/${segUuid(miembroId)}/retiro`, { metodo: 'POST', cuerpo: { dia } });
}
